const streakValues = [2, 5, 10, 25, 50, 100, 200, 300, 400, 500]

export default streakValues
